import { Injectable } from '@angular/core';
import { AuthHttpClient } from '../auth-http-service/auth-http.service';
import { AppConfigService } from '../app-config-service/app-config.service';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class AssetService {

  constructor(private http: AuthHttpClient, private appConfigService: AppConfigService,  private sanitizer: DomSanitizer) { }

  getLogo() {
    return this.http.get(this.appConfigService.logoGet);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/asset-service/asset.service.ts